/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".gastropay-settings[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{text-transform:uppercase;font-size:13px;font-weight:700;margin:0 0 15px 10px;cursor:pointer}"];
export { styles as styles };
